module.exports = __webpack_public_path__ + "static/BTP_stopwatch-de579936af5d7b2eb3716e30fcd98cbf.png";